import React, { useEffect, useState } from "react"
import { Loader2 } from "lucide-react"
import { useToast } from "src/components/ui/toast"
import { useDuesDashboard } from "src/features/collections/hooks/useDuesDashboard"
import DuesSummaryCards from "src/features/collections/components/DuesSummaryCards"
import DuesTable from "src/features/collections/components/DuesTable"
import ProjectFilter from "src/features/collections/components/ProjectFilter"

export default function CollectionsDashboardPage() {
  const { toast } = useToast()
  const [projectId, setProjectId] = useState("")
  const { data, loading, fetch } = useDuesDashboard()

  useEffect(() => {
    const filters = {}
    if (projectId) filters.project_id = projectId
    fetch(filters).catch((err) => {
      if (err?.response?.status === 403) {
        toast({ variant: "destructive", title: "Error", description: "You don't have permission to view collections." })
      }
    })
  }, [projectId])

  return (
    <div className="mx-auto max-w-[1200px]">
      <div className="mb-5 flex items-center justify-between">
        <ProjectFilter value={projectId} onChange={setProjectId} />
      </div>

      {loading ? (
        <div className="flex items-center gap-2 p-8 text-sm text-slate-500">
          <Loader2 className="h-4 w-4 animate-spin" /> Loading…
        </div>
      ) : !data ? (
        <EmptyState />
      ) : (
        <>
          <div className="mb-5">
            <DuesSummaryCards totals={data.totals} />
          </div>
          <DuesTable
            overdue={data.overdue || []}
            upcoming={data.upcoming || []}
            onRefresh={() => fetch(projectId ? { project_id: projectId } : {})}
          />
        </>
      )}
    </div>
  )
}

function EmptyState() {
  return (
    <div className="rounded-lg border border-dashed border-slate-300 bg-white p-12 text-center">
      <p className="text-[14px] text-slate-500">No collection data available.</p>
      <p className="mt-1 text-[12px] text-slate-400">
        Create bookings with payment schedules to see dues here.
      </p>
    </div>
  )
}
